import React, { useState, useEffect } from 'react'
import Main from '../Components/Main'
import PageContainer from '../Components/PageContainer'
import Modal from '../Components/Modal'
import CollapseCard from '../Components/CollapseCard'
import SourceList from '../Components/SourceList'
import SourceForm from '../Components/SourceForm'
import { getAllSources, saveSource, deleteSource } from '../Service/SourceService'
import { useToast } from '../Components/toast/ToastProvider'

const SourcePage = () => {
  const [sourceData, setSourceData] = useState([])
  const [sourceForm, setSourceForm] = useState({ title: '' })
  const [showModal, setShowModal] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchSources()
  }, [])

  const fetchSources = async () => {
    try {
      const res = await getAllSources()
      setSourceData(res.data)
    } catch (err) {
      toast(err.message || 'Failed to fetch sources')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!sourceForm.title) return alert('Please fill the source name')

      const duplicateName = sourceData.some((item) => item.id !== sourceForm.id && item.title?.trim().toLowerCase() === sourceForm.title?.trim().toLowerCase());
      if(duplicateName){
        toast("Source Name already exists","ERROR");
        return;
      }

    try {
      const payload = sourceForm.id ? {id:sourceForm.id,title:sourceForm.title}:{title:sourceForm.title}
      await saveSource(payload);
      toast(sourceForm.id? 'source update successfully':'source added successfully');
      fetchSources()
      handleCancel()
    } catch (err) {
      alert(err.message || 'Failed to save source',"ERROR")
    }
  }

  const handleEdit = (item) => {
    setSourceForm({id:item.id,title:item.title})
    setShowModal(true);
  }

  // const handleDelete = async (index) => {
  //   if (!window.confirm('Are you sure you want to delete this source?')) return
  //   try {
  //     await deleteSource(sourceData[index].id)
  //     toast('Source deleted successfully!', "SUCCESS")
  //     fetchSources()
  //   } catch (err) {
  //     toast(err.message || 'Failed to delete source',"ERROR")
  //   }
  // }

  const handleChange = (e) => {
    const { name, value } = e.target
    setSourceForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleCancel = () => {
    setSourceForm({ title: '' })
    setShowModal(false)
  }

  return (
    <Main>
      <PageContainer
        titlePage="Source"
        buttonText="ADD"
        onButtonClick={() => setShowModal(true)}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={sourceForm.id ? "Edit Source" : "Add Source"}
        >
          <SourceForm
            handleChange={handleChange}
            sourceForm={sourceForm}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        <CollapseCard title='Source'>
          <SourceList
            sourceData={sourceData}
            handleEdit={handleEdit}
            // handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  )
}

export default SourcePage
